<template>
  <div class="container-list" v-loading="loading">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        编辑巡查检查项
      </div>
    </div>
    <div class="ml20 mt20 f18 blue ">
      <i class="el-icon-back cursor" @click="$router.back()"> 返回</i>
    </div>
    <el-form ref="form" :model="form" label-width="110px" class="mt20" :rules="rules">
      <el-row :gutter="20">
        <!-- <el-col :span="10">
                    <el-form-item label="上级检查项" prop="h_check">
                        <el-input v-model="form.h_check" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col> -->
        <el-col :span="10">
          <el-form-item label="本级排序号" prop="ordernumber">
            <el-input type="number" min="0" v-model="form.ordernumber" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="检查项" prop="checklist">
            <el-input type="textarea" :rows="3" v-model="form.checklist" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="备注" prop="remarks">
            <el-input type="textarea" :rows="3" v-model="form.remarks" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <div class="action-line">
          <h3 class="ml20">巡查巡检明细</h3>
          <el-button size="mini" @click="addOne">新增明细</el-button>
        </div>
        <div class="action-bet">
          <div class="ml20 mx">明细内容</div>
          <div class="ml20 mx">排序</div>
        </div>
        <el-form-item v-for="(item, index) in form.checkDetail" :key="index" label-width="0" inline>
          <el-col :span="10">
            <el-input v-model="item.detail_content" placeholder="请输入"></el-input>
          </el-col>

          <el-col :span="10">
            <el-input type="number" min="0" v-model="item.sort_order" placeholder="请输入"></el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="danger" size="mini" @click="delateOne(index)">删除</el-button>
          </el-col>
        </el-form-item>
      </el-row>

      <div class="btn-box center">
        <el-button type="primary" @click="onSubmit">保存</el-button>

        <el-button type="primary" class="ml20" @click="$router.back()">返回</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getDetail } from "../../api/safety";
export default {
  data() {
    return {
      loading: false,
      status: 1,
      m_uuid: this.$route.query.m_uuid || "",
      h_check: this.$route.query.checklist || "",
      form: {
        h_check: "",
        ordernumber: "",
        checklist: "",
        remarks: "",
        h_uuid: "",
        checkDetail: [{ detail_content: "", sort_order: "" }],
      },
      rules: {},
    };
  },
  created() {
    if (this.status && !this.h_check && this.m_uuid) {
      this.status = 1; //编辑
      this.getList();
    } else if (this.h_check) {
      this.status = 0; //新增
      this.form.h_check = this.h_check;
      this.form.h_uuid = this.m_uuid;
    } else {
      this.status = 0;
    }
    // console.log(this.m_uuid)
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // getList(){
    //     var data = this.$route.query.data
    //     this.form.checklist = data.checklist
    //     this.form.ordernumber = data.ordernumber
    //     this.form.remarks = data.remarks
    // },
    getList() {
      this.loading = true;
      this.$post("/inspectionWenWu/editcheck", { m_uuid: this.m_uuid }).then((res) => {
        // console.log(res)
        this.form = res.data.list[0];
        this.loading = false;
      });
    },
    delateOne(index) {
      this.form.checkDetail.splice(index, 1);
    },
    addOne() {
      this.form.checkDetail.push({ detail_content: "", sort_order: "" });
    },
    save() {
      let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
      let api = this.status ? "/inspectionWenWu/savecheckagain" : "/inspectionWenWu/savecheck";
      let isre = false;
      this.form.ordernumber = Number(this.form.ordernumber);
      if (Object.is(this.form.ordernumber, NaN)) {
        this.form.ordernumber = "";
        isre = true;
      }

      this.form.checkDetail.map((item) => {
        item.sort_order = Number(item.sort_order);
        if (Object.is(item.sort_order, NaN)) {
          isre = true;
          item.sort_order = "";
        }
        return item;
      });
      if (isre) {
        this.$message.error("请输入正确的排序号");
        loading.close();
        return;
      }
      this.$post(api, this.form)
        .then((res) => {
          // this.$message.success("保存成功");
          this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });

          loading.close();
          this.$router.back();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped>
.action-line {
  display: flex;
  width: 85%;
  padding-right: 15px;
  justify-content: space-between;
}
.action-bet {
  width: 85%;
  margin: 20px 0;
  display: flex;
  justify-content: center;
}
.mx {
  flex: 1;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
